var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 17.4173V18.334H2.75V17.4173L4.58333 15.584V10.084C4.58333 7.24232 6.44417 4.73982 9.16667 3.93315C9.16667 3.84148 9.16667 3.75898 9.16667 3.66732C9.16667 3.18109 9.35982 2.71477 9.70364 2.37096C10.0475 2.02714 10.5138 1.83398 11 1.83398C11.4862 1.83398 11.9525 2.02714 12.2964 2.37096C12.6402 2.71477 12.8333 3.18109 12.8333 3.66732C12.8333 3.75898 12.8333 3.84148 12.8333 3.93315C15.5558 4.73982 17.4167 7.24232 17.4167 10.084V15.584L19.25 17.4173ZM12.8333 19.2507C12.8333 19.7369 12.6402 20.2032 12.2964 20.547C11.9525 20.8908 11.4862 21.084 11 21.084C10.5138 21.084 10.0475 20.8908 9.70364 20.547C9.35982 20.2032 9.16667 19.7369 9.16667 19.2507",
    fill: "#ACB1BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.fea37c771b87314655b672735b044e13.svg";
export { ForwardRef as ReactComponent };